"use client";

import { useParams } from "next/navigation";
import { FC } from "react"

const TermsPortugueseClient: FC = () => {
  const { locale } = useParams();

  return (
    <div className="flex flex-col bg-black-900 px-9 py-8 gap-4 rounded-2xl items-start">
      <h3 className="text-title-lg">
        Avisos legais.
      </h3>

      <p>
        Arena Pro Gaming. <a className="text-aqua-300" href="http://www.apg.gg/">www.apg.gg</a>
      </p>

      <h4 className="text-title-md">Termos e Condições.</h4>

      <p>
        Início efetivo: 01 de março de 2024.
      </p>

      <h4 className="text-title-md">Introdução.</h4>

      <p>
        Bem-vindo ao Arena Pro Gaming (APG)
      </p>

      <p>
        Neste contrato de termos e condições descrevem-se as regras e regulamentos para o uso do site: <a className="text-aqua-300" href="http://www.apg.gg/">www.apg.gg</a> o qual está destinado a ser uma plataforma, cujo objetivo é conectar os diferentes usuários que fazem parte da comunidade de videogames e e-sports a nível global.
      </p>

      <p>
        Ao acessar e usar este site, você está aceitando os termos e condições aqui descritos, além da nossa <a className="text-aqua-300" href={`/${locale}/privacy-policy`}>política de privacidade</a>. Ao aceitar estes acordos em seu nome ou em nome de qualquer outra entidade, você declara e garante que é uma pessoa física com plena capacidade ou uma pessoa jurídica que atua através de uma pessoa física que tem o poder ou a autoridade para celebrar um contrato em seu nome e representação, pelo que tem plena autoridade legal para vincular a você ou a essa entidade a estes acordos, também aceita que os leu e compreendeu na íntegra. Caso não concorde ou não tenha a autoridade legal para se vincular, deverá abster-se de utilizar o nosso site <a className="text-aqua-300" href="http://www.apg.gg/">www.apg.gg</a>.
      </p>

      <p>
        É importante mencionar que, se você se registrar em nosso site, utilizando informações próprias ou de outra entidade, será considerado que você representa essa parte e ao navegar em nosso site vinculará você ou essa entidade a estes acordos e que, nesse caso, ao utilizar a palavra &quot;você&quot; em cada um desses contratos estará se referindo a essa entidade.
      </p>

      <p>
        Em caso de ter algum tipo de dúvida, dúvida ou observação com relação ao nosso acordo de <b>termos e condições</b> ou <b>política de privacidade</b>, você pode nos contatar nas informações descritas na seção de <b>informações de contato</b> ou diretamente através do nosso e-mail: hola@apg.gg.
      </p>

      <p>
        Agradecemos o uso correto deste site, que tem como objetivo ser uma ferramenta de construção para o desenvolvimento e avanço das tecnologias e serviços relacionados à comunidade de videogames e e-sports a nível global, gerando um espaço onde os usuários podem criar um perfil informativo, com um link único, onde se encontra um resumo de quem são, a quem representam, as atividades a que se dedicam, os serviços que oferecem, entre outras coisas; melhorando notavelmente a visibilidade dos usuários e dos potenciais patrocinadores, permitindo assim agilizar o processo de encontrar novos talentos e criar relações novas ou preexistentes entre os membros da comunidade acima mencionada.
      </p>

      <p>
        Estas condições regem o uso que os usuários fazem ao navegar em <a className="text-aqua-300" href="http://www.apg.gg/">www.apg.gg</a> e qualquer um de seus serviços, funções, aplicativos, produtos, tecnologias e softwares presentes e futuros que estejam em desenvolvimento ou possam ser aplicados, exceto na situação em que se indique expressamente que se aplicam outras condições diferentes das descritas neste documento.
      </p>

      <h4 className="text-title-md">Definições.</h4>

      <p>
        Nesta seção, você encontrará as definições de cada termo usado neste contrato para esclarecer as informações contidas neste documento:
      </p>

      <ul className="list-decimal pl-8 space-y-4">
        <li>
          <strong>Site web:</strong> é um espaço virtual na internet composto por um conjunto de páginas web conectadas entre si e hospedadas em um servidor web.
        </li>
        <li>
          <strong>Usuário:</strong> é uma pessoa que utiliza um serviço de rede e possui uma conta de usuário na qual se identifica no sistema por um nome de usuário.
        </li>
        <li>
          <strong>Conteúdo:</strong> todo o conjunto de informações encontradas no site.
        </li>
        <li>
          <strong>Administrador:</strong> pessoa responsável por gerenciar os recursos e realizar ações para o correto funcionamento do site.
        </li>
        <li>
          <strong>eSports:</strong> termo em inglês para se referir aos esportes eletrônicos, que são todo o ambiente esportivo que se desenvolve em relação aos videogames, como competições e eventos de nível profissional.
        </li>
        <li>
          <strong>Videogame:</strong> software ou jogo eletrônico que permite que um ou mais jogadores interajam com um dispositivo eletrônico que exibe imagens de vídeo, que são visualizadas em uma tela ou refletor.
        </li>
        <li>
          <strong>Função:</strong> título que um usuário possui para conceder a ele uma tarefa ou função a ser desempenhada em um determinado contexto.
        </li>
        <li>
          <strong>Cookies:</strong> entenda cookie como um arquivo de texto que um servidor de páginas web coloca no disco rígido do usuário. Os cookies não podem ser usados para executar programas ou enviar vírus para computadores. Os cookies são atribuídos exclusivamente e apenas um servidor web no domínio que emitiu o cookie pode lê-los.
        </li>
      </ul>

      <h4 className="text-title-md">Em relação aos cookies.</h4>

      <p>
        Nosso site usa cookies para ajudar a personalizar a experiência de nossos usuários online e manter as sessões de cada usuário em operação. Ao navegar em <a className="text-aqua-300" href="http://www.apg.gg/">www.apg.gg</a>, você concorda em usar os cookies necessários.</p>

      <p>
        Podemos usar cookies para coletar, armazenar e rastrear informações para fins estatísticos ou de marketing para operar nosso site.
      </p>

      <h4 className="text-title-md">Informação geral.</h4>

      <p>
        A seguir, você encontrará seus direitos e responsabilidades adquiridos ao aceitar este contrato e usar o site. Estes termos não precisam ser assinados para serem vinculativos, pois você indica seu consentimento ao usar este site.
      </p>

      <p>
        Não vendemos os dados pessoais de nossos usuários nem compartilhamos informações que possam identificá-los diretamente (como nome, endereço de e-mail ou outras informações de contato). Nossa <a className="text-aqua-300" href={`/${locale}/privacy-policy`}>política de privacidade</a> explica como coletamos e usamos os dados pessoais de nossos usuários para fornecer todos os serviços descritos a seguir.
      </p>

      <p>
        Os serviços, atividades e informações que podem ser oferecidos ou encontrados neste site, seja pela APG ou por seus usuários registrados, não devem ser usados para fins ilegais ou não autorizados. Ao usar o site <a className="text-aqua-300" href="http://www.apg.gg/">www.apg.gg</a>, você deve cumprir todas as leis internacionais aplicáveis, incluindo as leis locais de seu país de residência, que doravante serão chamadas de &quot;leis aplicáveis&quot;.
      </p>

      <p>
        Você concorda que, ao usar este site, você estará em conformidade com todas as leis aplicáveis e estes acordos. Portanto, você concorda com o seguinte:
      </p>

      <ul className="list-item pl-8 space-y-4">
        <p>
          i. Não usar este site de forma ilegal e de forma que promova ou incentive atividades ilegais, incluindo (entre outras) a violação de direitos autorais.
        </p>
        <p>
          ii. Não tentar obter acesso não autorizado a este site ou a qualquer rede, servidor, sistema operacional, banco de dados ou informação relacionada a este site.
        </p>
        <p>
          iii. Não modificar, adaptar, traduzir ou realizar engenharia reversa em qualquer parte deste site, exceto na medida expressamente permitida por estes acordos ou por lei.
        </p>
      </ul>

      <h4 className="text-title-md">Sobre nossos serviços.</h4>

      <p>
        Devido à natureza do nosso site, ao se registrar e criar um perfil em <a className="text-aqua-300" href="http://www.apg.gg/">www.apg.gg</a>, você terá a experiência de ser conectado com as pessoas e organizações que lhe interessam através do uso dos dados que você insere em seu perfil. Gerando assim novas relações com pessoas, grupos, negócios, organizações e demais membros da comunidade de videogames e e-sports.
      </p>

      <p>
        Em nosso site você poderá personalizar seu perfil e adicionar funções ou categorias que podem ajudá-lo a ser encontrado ou a descrever o que você faz mais facilmente, tais como: caster, streamer, host, gerente, CEO, cosplayer, gráficos, editor de vídeo, broadcast, observador, organizador, entre outros. Além disso, você pode adicionar imagens em uma galeria para reforçar as conquistas e participações que cada usuário tem dentro da comunidade.
      </p>

      <p>
        O usuário poderá selecionar a privacidade de seu perfil entre pública e privada, de acordo com suas preferências, bem como um apelido ou apelido que será de sua livre escolha, proibindo apenas aquelas palavras que possam ser ofensivas, prejudiciais ou que possam incitar o ódio.
      </p>

      <p>
        Além disso, os usuários poderão adicionar links externos ao seu perfil para redirecionar os visitantes para suas redes sociais ou outras plataformas.
      </p>

      <p>
        É importante salientar que promovemos a segurança, a proteção e a integridade de nossos serviços; combatemos comportamentos prejudiciais e protegemos nossa comunidade de usuários. Caso encontre conteúdo contrário ao exposto acima que contenha ou sugira comportamento que possa ser prejudicial ao nosso site ou aos membros da nossa comunidade, podemos aplicar as medidas cabíveis em virtude da nossa avaliação, o que pode incluir o envio de notificações, a oferta de ajuda, a remoção de conteúdo, a remoção ou restrição do acesso a determinadas funções, a desativação de uma conta ou o contato com as autoridades policiais ou judiciais, conforme o caso.
      </p>

      <p>
        Compartilharemos dados que coletamos sobre os usuários quando detectamos que uma pessoa usa nosso site ou qualquer informação ou serviço relacionado de forma inadequada ou demonstra comportamento prejudicial, ou para ajudar a manter a segurança de nosso site, nossos usuários e nossa comunidade, tudo isso sempre de acordo com a legislação aplicável. Poderemos acessar, armazenar, usar e compartilhar qualquer informação que coletamos sobre nossos usuários quando se acredita de boa fé que isso é algo que a lei permite ou exige. Para mais informações sobre este assunto, consulte nossa <a className="text-aqua-300" href={`/${locale}/privacy-policy`}>política de privacidade</a>.
      </p>

      <p>
        Como desenvolvedores, estamos constantemente pesquisando formas de melhorar nossos serviços. Realizamos pesquisas constantemente para desenvolver, testar e melhorar nosso site, incluindo a análise dos dados que temos sobre nossos usuários. Nossa <a className="text-aqua-300" href={`/${locale}/privacy-policy`}>política de privacidade</a> explica como usamos os dados para embasar essas pesquisas com o objetivo de desenvolver e melhorar nossos serviços.
      </p>

      <p>
        Nosso site existe com o objetivo de ajudar nossos usuários a encontrar e se conectar com pessoas, grupos, empresas, organizadores e outros membros da comunidade de videogames e e-sports, buscando que a experiência seja uniforme, sem interrupções, garantindo ao usuário o acesso aos serviços que oferecemos.
      </p>

      <p>
        Para que isso funcione corretamente em nível internacional, precisamos transferir conteúdo e dados para nossos data centers, parceiros, provedores de serviços e sistemas, incluindo regiões fora de seu país de residência, armazená-los e distribuí-los entre eles.
      </p>

      <h4 className="text-title-md">Condições para acessar nossos serviços.</h4>

      <p>
        Ao navegar em nosso site apg.gg, você declara cumprir todas as condições contempladas a seguir:
      </p>

      <ul className="list-inside pl-8 space-y-4">
        <li>
          i. <strong>Condição de idade:</strong> você deve ter pelo menos treze (13) anos de idade e ter a supervisão e aprovação de seu representante ou tutor caso tenha menos de dezoito (18) anos de idade. Da mesma forma, você deve ter a maioridade em seu país ou região para se candidatar a oportunidades de trabalho e participar de funções relacionadas ao emprego.
        </li>
        <li>
          ii. <strong>Condição de registro:</strong> as informações fornecidas à nossa base de dados devem ser precisas e atualizadas durante o processo de registro. Cada usuário é responsável por manter a confidencialidade de sua senha e de toda a atividade que ocorrer em sua respectiva sessão.
        </li>
        <li>
          iii. <strong>Comportamento e conteúdo:</strong>é proibido conteúdo ofensivo, discriminatório, depreciativo, ilegal ou que viole os direitos, especialmente os de propriedade intelectual, de terceiros, sejam pessoas físicas ou jurídicas. apg.gg se reserva o direito de remover conteúdo que viole ou seja contrário a estas condições e de tomar medidas contra o(s) usuário(s) responsável(is).
        </li>
        <li>
          iv. <strong>Condição de oportunidades de trabalho:</strong>somente usuários maiores de idade em seus países ou regiões podem se candidatar a oportunidades de trabalho encontradas no site. Apg.gg não se responsabiliza pelas transações entre empregadores e candidatos.
        </li>
        <li>
          v. <strong>Condição de respeito:</strong>cada usuário tem o dever de respeitar os demais usuários, incluindo as opiniões e conteúdos que eles compartilham ou publicam. É proibida a participação em atividades ou comportamentos que possam intimidar, insultar, assediar ou prejudicar outros usuários, membros ou não da comunidade apg.gg.
        </li>
        <li>
          vi. <strong>Exclusão de conta:</strong> apg.gg se reserva o direito de suspender, fechar ou excluir contas de usuários sem aviso prévio caso tenham violado algum dos parâmetros encontrados neste acordo ou no de <a className="text-aqua-300" href={`/${locale}/privacy-policy`}>política de privacidade</a>.
        </li>
      </ul>

      <h4 className="text-title-md">Licença.</h4>

      <p>
        Salvo indicação em contrário, a Arena Pro Gaming e seus licenciantes detêm os direitos de propriedade intelectual de tudo relacionado ao site <a className="text-aqua-300" href="http://www.apg.gg/">www.apg.gg</a>, portanto, todos os direitos de propriedade intelectual são reservados. Os usuários podem acessar e navegar no site sujeitos às restrições estabelecidas nestes acordos de <strong>termos e condições</strong> e <a className="text-aqua-300" href={`/${locale}/privacy-policy`}>política de privacidade</a>.
      </p>

      <p>
        É proibida a cópia, republicação, venda, aluguel ou sublicenciamento de material que não seja de sua autoria neste site.
      </p>

      <p>
        Este site oferece aos usuários a oportunidade de publicar e trocar opiniões e informações em determinadas áreas. A Arena Pro Gaming e seus licenciantes não filtram, editam, publicam ou controlam os comentários ou postagens antes de sua presença no site. Os comentários ou postagens refletem os pontos de vista e opiniões do usuário que os gera. Na medida permitida pelas leis aplicáveis, a Arena Pro Gaming não será responsável pelas postagens, comentários, danos, despesas ou responsabilidades geradas.
      </p>

      <p>
        A Arena Pro Gaming se reserva o direito de monitorar todas as postagens e comentários gerados no site e remover aqueles que possam ser considerados inapropriados, ofensivos ou que violem este acordo de <b>termos e condições</b>.
      </p>

      <p>
        Ao usar este site, você declara que tem o direito de fazer postagens, tendo em mente que você deve ter todas as licenças e consentimentos necessários para fazê-lo e que elas não violam nenhum direito de propriedade intelectual, incluindo, entre outros, direitos autorais, patentes ou marcas registradas de terceiros. Além disso, você declara que os comentários ou postagens que você gera não contêm nenhum material difamatório, calunioso, ofensivo, indecente ou ilegal que seja uma invasão de privacidade.
      </p>

      <h4 className="text-title-md">Atribuição.</h4>
      
      <p>
        As imagens de emojis utilizadas nesta plataforma são fornecidas por X (anteriormente Twitter) e estão disponíveis sob a licença Creative Commons Attribution 4.0. Você pode encontrar mais detalhes sobre esta licença em <a className="text-aqua-300" href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noreferrer">Creative Commons</a>.
      </p>
    </div>
  )
}

export default TermsPortugueseClient